import React, {useState} from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {INetworkDiscoveryDevice} from '../../../../../states/connectivity-guru-data/types';
import {smallDevicesOutlined, smallWifi} from '../../icons';
import {ITranslate} from '../../../../../services/LocalizationService';
import {Tooltip} from '../Tooltip';
import {observer} from 'mobx-react';

const DEFAULT_TOOLTIP_SIZE = 22;
const RIGHT_TOOLTIP_SIZE = 16;

interface DevicesProps {
    networkDiscoveryDevices: INetworkDiscoveryDevice[];
    ssid?: string;
    translate: ITranslate;
    platformType?: string;
    deviceModel?: string;
}

interface TooltipState {
    show: boolean;
    content: string;
    x: number;
    y: number;
}

@observer
export class Devices extends TechseeBaseComponent<DevicesProps> {
    private tooltipState: TooltipState = {
        show: false,
        content: '',
        x: 0,
        y: 0
    };

    private showTooltip = (event: React.MouseEvent, content: string, size = DEFAULT_TOOLTIP_SIZE) => {
        if (content.length > size) {
            const rect = event.currentTarget.getBoundingClientRect();
            this.tooltipState = {
                show: true,
                content,
                x: rect.left + rect.width / 2,
                y: rect.top - 10
            };
            this.forceUpdate();
        }
    };

    private hideTooltip = () => {
        this.tooltipState = {
            show: false,
            content: '',
            x: 0,
            y: 0
        };
        this.forceUpdate();
    };

    renderInternal() {
        const {networkDiscoveryDevices, translate, deviceModel, platformType} = this.props;

        return (
            <div className='tab-box-container'>
                <div className='tab-box-icons-and-description padding-10'>
                    <div className={'center icon'}>{smallDevicesOutlined}</div>
                    <span>{networkDiscoveryDevices.length}</span>
                    <span>{translate('CONNECTIVITY_GURU.WIFI_SCAN.CONNECTED_DEVICES')}</span>
                </div>
                {networkDiscoveryDevices &&
                    networkDiscoveryDevices.map((item, idx) => (
                        <div key={idx} className='channel-box'>
                            <div className='tab-box-left-panel'>
                                <div className='tab-box-icons-and-description padding-0 margin-b-0 '>
                                    <span
                                        className={'bold-500 ellipsis'}
                                        onMouseEnter={(e) => this.showTooltip(e, item.name)}
                                        onMouseLeave={this.hideTooltip}>
                                        {item.name}
                                    </span>
                                </div>
                                <div className='tab-box-icons-and-description padding-0 margin-b-0'>
                                    <span
                                        className={'ellipsis'}
                                        onMouseEnter={(e) => this.showTooltip(e, item.ip)}
                                        onMouseLeave={this.hideTooltip}>
                                        {item.ip}
                                    </span>
                                </div>
                            </div>
                            <div className='tab-box-right-panel'>
                                <div className='tab-box-icons-and-description padding-0 margin-b-0'>
                                    <span
                                        className={'bold-500 small-ellipsis'}
                                        onMouseEnter={(e) =>
                                            this.showTooltip(e, item.manufacturer || 'N/A', RIGHT_TOOLTIP_SIZE)
                                        }
                                        onMouseLeave={this.hideTooltip}>
                                        {' '}
                                        {item.manufacturer || 'N/A'}
                                    </span>
                                </div>
                                <div className='tab-box-icons-and-description padding-0 margin-b-0'>
                                    <div className={'center icon'}>{smallDevicesOutlined}</div>
                                    <span
                                        className={'bold-500 small-ellipsis'}
                                        onMouseEnter={(e) =>
                                            this.showTooltip(e, item.model || 'N/A', RIGHT_TOOLTIP_SIZE)
                                        }
                                        onMouseLeave={this.hideTooltip}>
                                        {' '}
                                        {item.model || 'N/A'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                <Tooltip
                    show={this.tooltipState.show}
                    content={this.tooltipState.content}
                    x={this.tooltipState.x}
                    y={this.tooltipState.y}
                />
            </div>
        );
    }
}
